// src/userDashboard/layouts/UserLayout.tsx
import React, { useEffect, Suspense } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useSidebar } from '../app/providers';
import { useUserContext } from '../contexts/userContext';
import { LoadingSpinner } from '../shared/components';

import Header from './Header';
import Sidebar from './Sidebar';

const UserLayout: React.FC = () => {
    const { userProfile, loadingProfile } = useUserContext();
    const { isCollapsed } = useSidebar();
    const navigate = useNavigate();

    // Check auth
    useEffect(() => {
        if (!loadingProfile && !userProfile) {
            navigate('/sign-in'); // Redirect to existing sign-in
        }
    }, [userProfile, loadingProfile, navigate]);

    if (loadingProfile) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-slate-50">
                <div className="flex flex-col items-center gap-3">
                    <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
                    <p className="text-sm text-slate-500">Loading Dashboard...</p>
                </div>
            </div>
        );
    }

    if (!userProfile) return null;

    return (
        <div className="min-h-screen bg-slate-50">
            {/* Sidebar */}
            <Sidebar />

            {/* Main Content */}
            <div
                className={`
          transition-all duration-300
          ${isCollapsed ? 'lg:pl-[72px]' : 'lg:pl-64'}
        `}
            >
                <Header />

                <main className="pt-16 min-h-screen">
                    <div className="p-4 lg:p-6">
                        <Suspense fallback={<div className="h-[50vh] flex items-center justify-center"><LoadingSpinner /></div>}>
                            <Outlet />
                        </Suspense>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default UserLayout;
